<template>
  <div class="row">
    <div class="actions">
      <input type="button" :value="backLabel" class = "btn btn-back" @click="$emit('back')">
      <input type="button" :value="goLabel" class = "btn btn-go" @click="$emit('go')" :disabled="buttonDisabled">
    </div>
  </div>
</template>

<script>

export default{
  props: {
    backLabel: {
      type: String,
      required: true
    },
    goLabel: {
      type: String,
      required: true
    },
    buttonDisabled: {
      type: Boolean
    }
  }
}
</script>
